class AEvent {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const week = ["日", "月", "火", "水", "木", "金", "土"];
    const today = new Date();
    // 月末だとずれる可能性があるため、1日固定で取得
    var showDate = new Date(today.getFullYear(), today.getMonth(), 1);
    
    
    // 初期表示
    $('.calendar').each(function() {
      showProcess(today, this);
    });

    // 前の月表示
    $('.prev').on('click', function() {
      showDate.setMonth(showDate.getMonth() - 1);
      showProcess(showDate);
    })
    
    // 次の月表示
    $('.next').on('click', function() {
      showDate.setMonth(showDate.getMonth() + 1);
      showProcess(showDate);
    })

    
    // カレンダー表示
    function showProcess(date) {
      var year = date.getFullYear();
      var month = date.getMonth();
      $('.js-year').html(year);
      $('.js-month').html(month + 1);
    
      var calendar = createProcess(year, month);
      $('.calendar').html(calendar);

      $('.js-calendar-date').on('click', function() {
        $('.js-calendar-date').removeClass('is-active');
        $(this).addClass('is-active');
        $('.js-date').text($(this).text());
        $('.js-date-text').css({'display': 'inline'});
        sort_ajax();
      })
    }
    
    // カレンダー作成
    function createProcess(year, month) {
      // 曜日
      var calendar = "<table><tr class='dayOfWeek'>";
      for (var i = 0; i < week.length; i++) {
        calendar += "<th>" + week[i] + "</th>";
      }
      calendar += "</tr>";
    
      var count = 0;
      var startDayOfWeek = new Date(year, month, 1).getDay();
      var endDate = new Date(year, month + 1, 0).getDate();
      var lastMonthEndDate = new Date(year, month, 0).getDate();
      var row = Math.ceil((startDayOfWeek + endDate) / week.length);
    
      // 1行ずつ設定
      for (var i = 0; i < row; i++) {
        calendar += "<tr>";
        // 1colum単位で設定
        for (var j = 0; j < week.length; j++) {
          if (i == 0 && j < startDayOfWeek) {
            // 1行目で1日まで先月の日付を設定
            calendar += "<td class='disabled'>" + (lastMonthEndDate - startDayOfWeek + j + 1) + "</td>";
          } else if (count >= endDate) {
            // 最終行で最終日以降、翌月の日付を設定
            count++;
            calendar += "<td class='disabled'>" + (count - endDate) + "</td>";
          } else {
            // 当月の日付を曜日に照らし合わせて設定
            count++;
            if(year == today.getFullYear()
               && month == (today.getMonth())
               && count == today.getDate()){
              calendar += "<td class='today js-calendar-date'>" + count + "</td>";
            } else {
              calendar += "<td class='js-calendar-date'>" + count + "</td>";
            }
          }
        }
        calendar += "</tr>";
      }
      return calendar;
    }


    // ----------------------------
    // SP カレンダーモーダル
    // ----------------------------

    $('.js-modal, .js-close').on('click', function() {
      $('.is-modal').toggleClass('is-active');
      $('body').toggleClass('no-scroll');
    })


    // ----------------------------
    // ajaxで日付ソート
    // ----------------------------

    // let add_post_target = $('.x__ajax-add-post-target');

    // let load_btn = $('.load_btn');
    // let all_posts = load_btn.data("all-posts"); //カスタム投稿の全件数
    // let this_posts_num = load_btn.data("this-posts-num");
    // let add_posts_num = load_btn.data("add-posts-num");

    // load_btn.on("click", function () {
    //   //読み込み中はボタン非表示
    //   load_btn.addClass('is__hidden');

    //   //ajax処理。data{}のactionに指定した関数を実行、完了後はdoneに入る
    //   $.ajax({
    //     type: 'POST',
    //     url: ajaxurl,
    //     data: {
    //       'action': 'load_post_list_ajax', //functions.phpで設定する関数名
    //       'all_posts': all_posts,
    //       'this_posts_num': this_posts_num,
    //       'add_posts_num': add_posts_num,
    //     },
    //   })
    //   .done(function (data) { //my_ajax_action関数で取得したデータがdataに入る
    //     console.log(data);
    //     add_post_target.append(data);
    //     setTimeout(function () {
    //       add_post_target.find('.x__add-post').removeClass('is__hidden');
    //     }, 100);
    //     //表示件数を増やす
    //     this_posts_num = this_posts_num + add_posts_num;
    //     load_btn.attr('data-this-posts-num', this_posts_num);

    //     //まだ全件表示されていない場合、ボタンを再度表示
    //     if (all_posts > this_posts_num) {
    //       load_btn.removeClass('is__hidden');
    //     }
    //   })
    //   .fail(function () {
    //     alert('エラーが発生しました');
    //   })
    // });


    $('.js-prevMonth, .js-nextMonth').on("click", function() {
      $('.js-ttl').css({'display': 'block'});
      $('.js-date-text').css({'display': 'none'});
      $('.js-date').text('');
      sort_ajax();
    })


		var searchParams = new URLSearchParams( window.location.search );
		var url = location.href;
		var searchParams = new URL(url).searchParams;

    if(searchParams.get("p-cat")) {
      $('.js-cat').val(searchParams.get("p-cat"));
    }

    $('.js-cat').on("change", function() {
      $('.js-ttl').css({'display': 'block'});
      sort_ajax();
    })

    function sort_ajax(el) {
      $('.js-postList').animate({
        opacity: 0
      }, 100 );;
      let year = $('.js-year').eq(0).text();
      let month = $('.js-month').eq(0).text();
      let date;
      let cat;

      date = $('.js-calendar-date.is-active') ? $('.js-date').eq(0).text() : undefined;

      cat = $('.js-cat').val() ? $('.js-cat').val() : undefined;

      //ajax処理。data{}のactionに指定した関数を実行、完了後はdoneに入る
      $.ajax({
        type: 'POST',
        url: ajaxurl,
        data: {
          'action': 'load_post_sort_ajax', //functions.phpで設定する関数名
          'year': year,
          'month': month,
          'date': date,
          'cat': cat,
        },
      })
      .done(function (data) { //my_ajax_action関数で取得したデータがdataに入る
        if(data.length <= 3) {
          data = '<p>条件に該当するイベントはありません。<br>別の条件で検索してください。</p>';
        }
        $('.js-postList').html(data);
        $('.js-postList').animate({
          opacity: 1
        }, 100 );;
      })
      .fail(function () {
        alert('エラーが発生しました');
      })
    }
  }
}

// globals
class AccordionEvent {
  constructor(el,opt){
    this.el = el;
    this.event();
  }
  event(){

    if (window.matchMedia('(max-width: 767px)').matches) {

      $('.c-side__btn').on('click', function() {
        var findElm = $(this).next(".c-side__archiveList");
        $(findElm).slideToggle();
          
        // if($(this).hasClass('close')){//a-triggerにクラス名closeがあれば
        //   $(this).removeClass('close');//クラス名を除去し
        // }else{//それ以外は
        //   $(this).addClass('close');//クラス名closeを付与
        // }
      });
  
      $(window).on('load', function(){
        $(".open").each(function(index, element){
          var Title =$(element).children('.c-side__btn');
          $(Title).addClass('close');
          var Box =$(element).children('.c-side__archiveList');
          $(Box).slideDown(500);
        });
      });

    } else if (window.matchMedia('(min-width:768px)').matches) {
      //PC動作なし
    }
  }
}

class BarHidden {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    if($(location).attr('href').match(/_x_tr_sl=/)) {
      const body = document.querySelector("body")
      body.classList.add("mt-none")
    }
  }
}

var CFL = {
  UA: {
    raw: function raw() {
      return navigator.userAgent;
    },
    is: function is(_is) {
      var ua = CFL.UA.raw();
      if (_is === 'issp') {
        return CFL.UA.isSp();
      }
    },
    isSp: function isSp() {
      var ua = CFL.UA.raw();
      return ua.indexOf('iPhone') > 0 || ua.indexOf('iPod') > 0 || ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0;
    },
    isTablet: function() {
      var ua = CFL.UA.raw();
      if(ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0) {
      } else if (ua.indexOf('iPad') > -1
         || (ua.indexOf('Macintosh') > -1 && CFL.UA.Device.isTouch() )
         || ua.indexOf('Android') > 0) {
        return true;
      }

      return false;
    },
    isEdge: function() {
      return this.raw().indexOf('Edge') != -1;
    },
    isIE: function() {
      var ua = CFL.UA.raw();
      return this.raw().indexOf('Trident') != -1 ;
    }
  },
  Device: {
    isTouch: function() {
      return 'ontouchend' in document;
    }
  }
};

var isMobile = function () {
  return (window.matchMedia('(max-width: '+ APP.bp.mobile +'px)').matches)
}

var isPortrait = function() {
  let defaultOrientation = null;
  if('orientation' in window) {
    var o1 = (window.innerWidth < window.innerHeight);
    var o2 = (window.orientation % 180 == 0);
    defaultOrientation = (o1 && o2) || !(o1 || o2);
  }
  if('orientation' in window) {
    // defaultOrientationがtrueの場合、window.orientationが0か180の時は縦
    // defaultOrientationがfalseの場合、window.orientationが-90か90の時は横
    var o = (window.orientation % 180 == 0);
    if((o && defaultOrientation) || !(o || defaultOrientation)) {
      return true;
    } else {
      return false;
    }
  }
}
// 参考サイト
// https://hacknote.jp/archives/15289/

var cookie = {
	/**
	 * 取得
	 * @param {string} cookieName 取得するCookieの名前
	 */
	get : function(cookieName) {
		if (!navigator.cookieEnabled) return false;

		var getCookieAllData  = document.cookie,
		    getCookieAllDatas = getCookieAllData.split(';'),
		    getCookieDatas    = {},
		    cookieKeyValue    = [],
		    cookieKey         = '',
		    cookieValue       = '';

		var hashLength = function(arr) {
			var result = 0, key = false;

			if (typeof arr !== 'object') return false;

			for (key in arr) result++;

			return result;
		};

		for (var i = 0, len = getCookieAllDatas.length; i < len; i++) {
			if (getCookieAllDatas[i] && getCookieAllDatas[i] !== '') {
				cookieKeyValue = getCookieAllDatas[i].split('=');
				cookieKey      = cookieKeyValue[0].replace(/^\s+/, '');
				cookieValue    = '';

				if (cookieKeyValue[1]) {
					cookieValue = decodeURIComponent(cookieKeyValue[1]);
				}

				getCookieDatas[cookieKey] = cookieValue;
			}
		}

		if (hashLength(getCookieDatas) > 0) {
			if (cookieName && cookieName in getCookieDatas) {
				return getCookieDatas[cookieName];
			} else {
				return getCookieDatas;
			}
		} else {
			return '';
		}
	},

	/**
	 * 設定
	 * @param {string} cookieName 設定するCookieの名前
	 * @param {string} value 設定する値
	 * @param {string} domain 有効ドメイン
	 * @param {string} path 有効パス
	 * @param {string} expires 有効期限
	 * @param {boolean} secure セキュアとするか
	 * @return {boolean} 設定に成功した場合はtrue、失敗した場合はfalseを返す
	 */
	set : function(cookieName, value, domain, path, expires, secure) {
		if (!navigator.cookieEnabled || !cookieName || !value) return false;

		var date, dt, ts, ts_after;

		var setCookieData = cookieName + '=' + encodeURIComponent(value) + ';';

		if (domain) setCookieData += 'domain=' + domain + ';';

		if (path) setCookieData += 'path=' + path + ';';

		if (expires) {
      dt = new Date();
      ts = dt.getTime();

      // 1時間後
      ts_after = ts + (1000 * 60 * 60 * expires);

      date = new Date(ts_after);
			setCookieData += 'expires=' + date.toGMTString() + ';';
		}

		if (secure && secure === true && location.protocol.match(/https/)) {
			setCookieData += 'secure';
		}

		document.cookie = setCookieData;

		return true;
	},

	/**
	 * 削除
	 * @param {string} cookieName 削除するCookieの名前
	 * @return {boolean} 削除に成功した場合はtrue、失敗した場合はfalseを返す
	 */
	del : function(cookieName) {
		if (!navigator.cookieEnabled || !cookieName) return false;

		var getCookieDatas = this.get();

		if (getCookieDatas[cookieName]) {
			var setCookieData = cookieName + '=;',
			    date          = new Date(0);

			setCookieData += 'expires=' + date.toGMTString() + '';

			document.cookie = setCookieData;

			return true;
		}

		return false;
	}
};
class HamburgerEvent {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const SpTrigger = document.querySelector('.header__hum');
    const SpMenu = document.querySelector('.spMenu');
    const Overlay = document.querySelector('.spMenu__overlay');
    const Header = document.querySelector('.js-header');
    const body = document.querySelector('body');

    SpTrigger.addEventListener('click', () => {
      SpTrigger.classList.toggle('is-active')
      SpMenu.classList.toggle('is-active')
      Overlay.classList.toggle('is-active')
      Header.classList.toggle('is-active')
      body.classList.toggle('no-scroll')
    });
  }
}

class HeaderScroll {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $(window).on('scroll', function () {
      if ($('.mv').height() < $(this).scrollTop()) {
          $('.front-header').addClass('is-scroll');
          $('.spMenu').addClass('is-scroll');
      } else {
          $('.front-header').removeClass('is-scroll');
          $('.spMenu').removeClass('is-scroll');
      }
    });
  }
}

//noScroll
class ImgParallax {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    this.para_ele = document.querySelectorAll("." + this.el);
    this.para_ele.forEach((ele, index)=> {
      if(ele.classList.contains('js-parallax--reverse')) {
        this.translateY = '20px';
      } else {
        this.translateY = '-20px';
      }
      ele.classList.add(this.el + index);
      gsap.to('.' + this.el + index + ' img', {
        translateY: this.translateY,
        scrollTrigger: {
          trigger: '.' + this.el + index, // 要素がビューポートに入ったときにアニメーション開始
          start: 'top bottom',
          scrub: 3,
        }
      })
    })
  }
}

class InviewEvent {
  constructor(el, opt){
    this.el = el;
    this.all = this.el + '-all';
    this.eachUp = this.el + '-each';
    this.eachItem = this.el + '-eachItem';
    this.eachItemFast = this.el + '-eachItem-fast';
    this.eachItemDelay = this.el + '-eachItem-delay';
    if($(this.el).length > 0){
      this.event();
    }
  }
  event() {
    let options = {
      threshold: [0, 0.05, 0.1, 1]
    }
    let optionsAll = {
      threshold: [0, 0.9, 1]
    }
    const observerEnter = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio >= 0.05){
          item.classList.add('is-inview');
          if(item.classList.contains('js-inview-each')){
            this.inviewEachUp(item);
          }
          if(item.classList.contains('js-inview-lottie')){
            this.inviewLottie(item);
          }
          observerEnter.unobserve(item);
        }
      });
    }, options);
    const observerAll = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio >= 0.9){
          item.classList.add('is-inview');
          if(item.classList.contains('js-inview-each')){
            this.inviewEachUp(item);
          }
          observerAll.unobserve(item);
        } else {
          item.classList.remove('is-inview');
        }
      });
    }, optionsAll);
    const inviewItem = document.querySelectorAll(this.el);
    const inviewAllItem = document.querySelectorAll(this.all);
    inviewItem.forEach((e)=>{
      observerEnter.observe(e);
    });
    inviewAllItem.forEach((e)=>{
      observerAll.observe(e);
    });
  }
  inviewEachUp(item){
    $(item).find(this.eachItem).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.2 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
    $(item).find(this.eachItemFast).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.1 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
    $(item).find(this.eachItemDelay).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.5 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
  }
  inviewLottie(item){
    if($(item).hasClass('js-lottie-flow')) {
      lottie.flow();
    }
    if($(item).hasClass('js-lottie-no01')) {
      lottie.no01();
    }
    if($(item).hasClass('js-lottie-no02')) {
      lottie.no02();
    }
    if($(item).hasClass('js-lottie-no03')) {
      lottie.no03();
    }
    if($(item).hasClass('js-lottie-no04')) {
      lottie.no04();
    }
    if($(item).hasClass('js-lottie-no05')) {
      lottie.no05();
    }
    if($(item).hasClass('js-lottie-no06')) {
      lottie.no06();
    }
    if($(item).hasClass('js-lottie-no07')) {
      lottie.no07();
    }
  }
}

class MultilingualUrl {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){

    setTimeout(() => {
      const Link = document.querySelectorAll('.link');
      Link.forEach((el) => {
        const dataHref = el.dataset.href;
        el.setAttribute('href', dataHref);
      });
    },500);

  }
}

class PageTop {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    (function ($) {
      var pagetop = $('.footer__toTop');
        
      pagetop.click(function () {
        $('body, html').animate({
            scrollTop: 0
        }, 600);
        return false;
      });
    })(jQuery);
  }
}

class UnderHeaderScroll {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $(window).on('scroll', function () {
      if ($('.c-heading').height() < $(this).scrollTop()) {
          $('.spMenu').addClass('is-shadow');
          $('.under-header').addClass('is-shadow');
        } else {
          $('.spMenu').removeClass('is-shadow');
          $('.under-header').removeClass('is-shadow');
      }
    });
  }
}



(() => {

})();

//DOMContentLoaded
$(() => {
});

//images resources loaded
$(window).on('load', () => {

  $(window).trigger('loading');
});

//after loading animation
$(window).on('loading', () => {
  let imgParallax = new ImgParallax('js-parallax');
  let inviewEvent = new InviewEvent('.js-inview');
  let hamburgerEvent = new HamburgerEvent('spMenu');
  let Headerscroll = new HeaderScroll('front-header');
  let underHeaderscroll = new UnderHeaderScroll('under-header');
  let pageTop = new PageTop('footer__toTop');
  let aEvent = new AEvent('p-event');
  let accordionEvent = new AccordionEvent('c-side');
  let barHidden = new BarHidden('js-header');
  let multilingualUrl = new MultilingualUrl('p-multilingual');
});

// スマホ・タブレットの向き判定
// $(window).on('orientationchange', ()=>{
//   if(isPortrait()){
//     console.log('isPortrait');
//   } else {
//     console.log('isLandscape');
//   }
// });